import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import './index.css'

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Ensure clean render and catch errors early in dev
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

